export const PAGE_MENU = [
  {
    id: "enagaged_hcps",
    heading: "Engaged HCP's",
    value: "0",
    icon: "user-star",
    color: "primary",
    desc: "HCP's who are open to interacting with pharmaceutical companies.",
    path: "emsl/summary/engaged-hcps",
  },
  {
    id: "consented_leads",
    heading: "Consented Leads",
    value: "0",
    icon: "funnel",
    color: "success",
    desc: "HCP's who consented to be contacted.",
    path: "emsl/summary/consented-leads",
  },
  {
    id: "interactions",
    heading: "Interactions",
    value: "0",
    icon: "search-demo",
    color: "primary",
    desc: "Individuals who showed interest to witness a product demo.",
    path: "emsl/summary/interactions",
  },
  {
    id: "prescribers",
    heading: "Prescribers",
    value: "0",
    icon: "target",
    color: "success",
    desc: "Healthcare professionals likely to prescribe your products.",
    path: "emsl/summary/prescribers",
  },
];
